let init = false;
export const initGravitec = (id, model) => {
  if (init || model.config.isGuest) {
    return;
  }
  const checkIfUserHasAlias = (response) => {
    Gravitec.push([
      "segmentation.setAlias", id,
      function () { console.log("Alias has been set", id) },
      function (err) {
        console.log(err.message)
      }]);

    if (model.userIsOwner) {
      Gravitec.push(['getTags', function (tags) {
        var savedTags = [];
        tags.map((tag) => savedTags.push(tag));
        console.log(savedTags);
        if (savedTags.filter(item => item === model.config.userId).length === 0) {
          Gravitec.push([
            "segmentation.setTags", [this.model.config.creatorUserIdOfWorld],
            function () {
              console.log("Tags has been set");
            }])
        }
      }])
    }
  }

  const initUser = () => {
    init = true;
    Gravitec.push(["isSubscribed", function (success) {
      if (success) {
        checkIfUserHasAlias();
      }
    }]);
  }


  const checkForGravitec = () => {
    setTimeout(() => {
      if (!Gravitec) {
        checkForGravitec();
        return;
      }
      Gravitec.push(["init", { "autoRegister": true }]);
      initUser();
    }, 4000);
  }
  checkForGravitec();
}